<template>
	<div class="header-wrapper">
    <div class="header_left" v-if="screenWidth > 601">
      <img src="/static/images/logo_new.png" alt="" @click="$router.push('/Home')">
      <p @click="$router.push('/Home')">
        <i class="el-icon-sort"></i>
        {{ prodName ? prodName : deptName }}
      </p>
    </div>
    <!-- 站位用的 -->
    <div v-else></div>
    <div class="header_right" v-if="screenWidth > 600">
      <ul class="right_menu">
        <!-- <li @click="handleCommand('s')" v-if="userType==0" :class="{active : 2===curId}"><span>数据中心</span></li> -->
        <li @click="handleCommand('a')" v-if="isPlatformadmin" :class="{active : 0===curId}"><span>教务中心</span></li>
        <li @click="handleCommand('b')" :class="{active : 1===curId}"><span>个人中心</span></li>
      </ul>
      <div class="login-user">
        <el-dropdown @command="handleCommand" :show-timeout="0">
          <div class="user-name el-dropdown-link">
              <div class="imgBox">
                <img :src="imgUrl">
              </div>
              <div class="login-name">{{name}}</div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="a">教务中心</el-dropdown-item> -->
            <!-- <el-dropdown-item command="b">个人中心</el-dropdown-item> -->
            <el-dropdown-item command="d">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		data() {
			return {
        screenWidth: '',
        name:'',
        userType: '',
        // imgUrl:'../../../static/images/homepage/headPic.png',
        imgUrl:'../../../static/images/hed0.png',
        professional: sessionStorage.getItem('professional')?sessionStorage.getItem('professional'):2,
        isPlatformadmin: sessionStorage.getItem('isPlatformadmin'),
        curId: 0,
        prodName: sessionStorage.getItem('prodName'),
        deptName: sessionStorage.getItem('deptName')
			}
    },
    created(){
      if(this.$route.path.split('/')[1] == 'educa'){
        this.curId = 0
      }else if(this.$route.path.split('/')[1] == 'settings'){
        this.curId = 1
      }else if(this.$route.path.split('/')[1] == 'dataStatistics'){
        this.curId = 2
      }else{
        this.curId = 3
      }
      if(localStorage.getItem('isbinding')&&localStorage.getItem('isbinding')==0){
        this.$router.push({path:'/'})
      }
      this.name = sessionStorage.getItem('loginName');
      this.userType = sessionStorage.getItem('userType');
    },
    mounted(){
      this.screenWidth = document.body.clientWidth;
    },
		methods: {
      handleCommand(command){
        if(command == 'd'){
          this.$logOut()
        }else if(command == 'a'){
          this.$router.push('/educa')
        }else if(command == 'b'){
          this.$router.push('/settings')
        }else if(command == 's'){
          this.$router.push('/dataStatistics')
        }
      },
    },
    watch: {
      '$route' (to, from) {
        if(to.path.split('/')[1] == 'educa'){
          this.curId = 0
        }else if(to.path.split('/')[1] == 'settings'){
          this.curId = 1
        }else if(to.path.split('/')[1] == 'dataStatistics'){
          this.curId = 2
        }else{
          this.curId = 3
        }
      }
    }
	}

</script>

<style scoped lang="scss">
  .header-wrapper {
    width: 100%;
    height:64px;
    background:rgba(83,151,247,1);
    display: flex;
    justify-content: space-between;
    .header_left{
      display: flex;
      align-items: center;
      img{
        height: 38px;
        margin-left: 15px;
        margin-right: 15px;
      }
      p{
        font-size:16px;
        font-weight:normal;
        line-height:27px;
        color:rgba(255,255,255,1);
        position: relative;
        margin-left: 15px;
        cursor: pointer;
        &::after{
          content: '';
          position: absolute;
          left: -15px;
          top: 5px;
          width: 1px;
          height: 20px;
          background: #fff;
        }
        i{
          transform: rotate(90deg);
          margin-right: 5px;
          color:rgba(255,255,255,1);
        }
      }
    }
    .header_right{
      display: flex;
      .right_menu{
        display: flex;
        align-items: center;
        margin-right: 24px;
        li{
          position: relative;
          width: 100px;
          text-align: center;
          cursor: pointer;
          span{
            color: #fff;
            font-size:12px;
            font-weight:normal;
            letter-spacing:1px;
          }
          &::after{
            content: '';
            width: 1px;
            height: 12px;
            background: #fff;
            position: absolute;
            right: 0;
            top: 4px;
          }
        }
        .active{
          span{
            // color: darkorange;
            color: #fff;
            font-weight: 600;
            font-size: 14px;
          }
        }
      }
    }
    .login-user {
      position: relative;
      cursor: pointer;
      .login-name {
        margin-left: 6px;
        color: #fff;
        line-height: 20px;
      }
      .user-name {
        height: 64px;
        display: flex;
        align-items: center;
        .imgBox {
          width: 30px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          border: 1px solid #333;
          border-radius: 50%;
          img{
            height: 100%;
          }
        }
      }
      .el-dropdown {
        margin-right: 32px;
      }
      &:hover{
        .login-name {
          opacity: 0.8;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue